export interface Domains {
    domainsSignal: any | null;
    loadingSignal: boolean;
  }
  
  export const initialState: Domains = {
    domainsSignal: null,
    loadingSignal: false,
  };